import Polyglot from "node-polyglot";
import translations from "~/assets/translations/translations.json";

function getPolyglot(locale) {
  const phrases = translations.reduce((acc, curr) => {
    acc[curr["message-code"]] = curr[locale];
    return acc;
  }, {});
  return new Polyglot({ phrases, locale });
}

export default getPolyglot;
